import React from "react"

import * as Sentry from "@sentry/react"

import "@l2r-front/l2r-i18n"
import { AuthenticationContextProvider, MyUserContextProvider } from "@l2r-front/l2r-auth"
import { AlertsContextProvider, WSContextProvider } from "@l2r-front/l2r-query"
import { theme, ThemeProvider } from "@l2r-front/l2r-ui"
import { ApplicationContextProvider, ResourceLoader } from "@l2r-front/l2r-utils"

import { ErrorPage } from "../pages/ErrorPage"

export const appProviders = [
    <ThemeProvider theme={theme} />,
    <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorPage resetError={resetError} />} />,
    <ResourceLoader />,
    <ApplicationContextProvider />,
    <AlertsContextProvider />,
    <AuthenticationContextProvider />,
    <MyUserContextProvider />,
    <WSContextProvider />,
]